// File: ProfileDescription.js
import React from "react";
import { InfoIcon } from "lucide-react";

const ProfileDescription = ({ description }) => {
  return (
    <div className="mt-1 flex items-start">
      <InfoIcon className="h-4 w-4 mr-3" />
      <p className="text-xs text-gray-500">
        {description.substring(0, 400)} {description.length > 400 ? "..." : ""}
      </p>
    </div>
  );
};

export default ProfileDescription;
